// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3f5JF","col":"styles_col__hVeAR"};